import React from 'react';
import { StepProps } from '../MultiStepModal';
import { FormField, TextInput } from '../../ui';

type ClientType = 'INDIVIDUAL' | 'BUSINESS' | 'LANDLORD' | 'LETTING_AGENT';

const OPTIONS: Array<{ value: ClientType; label: string; desc: string }> = [
  { value: 'INDIVIDUAL', label: 'Individual', desc: 'Homeowner / tenant / single person.' },
  { value: 'BUSINESS', label: 'Business', desc: 'Company or commercial customer.' },
  { value: 'LANDLORD', label: 'Landlord', desc: 'Owns one or more rented properties.' },
  { value: 'LETTING_AGENT', label: 'Letting agent', desc: 'Manages properties on behalf of landlords.' },
];

export default function ClientIdentityStep({ data, onDataChange }: StepProps) {
  const clientType: ClientType = (data.clientType as ClientType) || 'INDIVIDUAL';
  const isBusiness = clientType === 'BUSINESS' || clientType === 'LETTING_AGENT';

  const setField = (field: string, value: any) => onDataChange({ [field]: value });

  return (
    <div className="step-form">
      <div className="step-header">
        <h3 className="step-form-title">Who are you adding?</h3>
        <p className="step-form-subtitle">
          Choose the best match — we'll adjust the fields accordingly.
        </p>
      </div>

      <div className="ui-wizard-section">
        <h4 className="ui-wizard-section-title">Client type</h4>
        <div className="ui-wizard-radio-group">
          {OPTIONS.map((opt) => (
            <button
              key={opt.value}
              type="button"
              className={`ui-wizard-radio ${clientType === opt.value ? 'selected' : ''}`}
              onClick={() => setField('clientType', opt.value)}
            >
              <span className="ui-wizard-radio-indicator" />
              <span>
                <span className="ui-wizard-radio-label">{opt.label}</span>
                <span className="ui-wizard-radio-desc">{opt.desc}</span>
              </span>
            </button>
          ))}
        </div>
      </div>

      <div className="ui-wizard-section">
        <h4 className="ui-wizard-section-title">
          {isBusiness ? 'Business details' : 'Primary contact'}
        </h4>

        <div className="ui-wizard-grid">
          <FormField
            label={isBusiness ? 'Primary contact name' : 'Full name'}
            required
            htmlFor="clientName"
          >
            <TextInput
              id="clientName"
              placeholder={isBusiness ? 'e.g. Jane Doe' : 'e.g. John Smith'}
              value={data.customerName || ''}
              onChange={(e) => setField('customerName', e.target.value)}
            />
          </FormField>

          {isBusiness && (
            <FormField label="Company / agency name" required htmlFor="companyName">
              <TextInput
                id="companyName"
                placeholder="e.g. Smith Properties Ltd"
                value={data.companyName || ''}
                onChange={(e) => setField('companyName', e.target.value)}
              />
            </FormField>
          )}
        </div>
      </div>
    </div>
  );
}
